// src/components/cards/card-carousel-news.tsx
import isEmpty from 'lodash/isEmpty';
import dynamic from 'next/dynamic';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';

const Image = dynamic(import('src/components/image'));

type Props = {
  data: any;
  showTitle?: boolean;
  showCategory?: boolean;
  showBlurb?: boolean;
  eventDataLayer?: any;
  external?: boolean;
  target?: string;
  vertical_image?: boolean;
  type?: 'FEATURE_IMAGE' | 'COVER_IMAGE' | 'CARD_LARGE' | 'CARD_MEDIUM' | 'CARD_SMALL' | 'NEXT_IMAGE' | string;
};

const CardCarouselNews = ({ data, showTitle = true, showCategory = true, showBlurb = false, eventDataLayer = {}, external = false, target = '', vertical_image = false, type }: Props) => {
  if (isEmpty(data)) return null;

  return (
    <CardWrapper className='card-carousel-news' >
      <a href={data?.link || data?.a || '#'} onClick={() => sendDataLayerGlobal({ ...eventDataLayer })} target={target}>
        <div className='card-thumb'>
          <Image
            type={type}
            image={vertical_image ? (data?.vertical_image ? data?.vertical_image : data?.image) : data?.image}
            title={data?.title}
            decorative={Boolean(showTitle)}
            external={external}
          />
        </div>
        <div className='card-content'>
          {showCategory && data?.subCategory?.th && <span className='category'>{data?.subCategory?.th}</span>}
          {showTitle && <h3 className='title'>{data?.title}</h3>}
          {showBlurb && data?.blurb && <p className='blurb'>{data?.blurb}</p>}
        </div>
      </a>
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  position: relative;
  display: block;
  border-radius: 5px;
  overflow: hidden;

  a {
    display: block;
    text-decoration: none;
  }

  &:hover {
    .card-thumb img {
      transform: scale(1.05);
    }
    .title {
      color: #ed1a3b;
    }
  }

  .card-thumb {
    position: relative;
    aspect-ratio: 16 / 9;
    overflow: hidden;

    .resolution-image,
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }
  }

  .card-content {
    padding: 15px 0;
    background: transparent;

    .category {
      display: inline-block;
      color: #ffffff;
      font-size: 12px;
      font-weight: 500;
      margin-bottom: 8px;
      text-transform: uppercase;
      border-left: 2px solid #ed1a3b;
      padding-left: 8px;
      line-height: 1.5;
    }

    .title {
      color: #fff;
      font-size: 18px;
      font-weight: 500;
      line-height: 1.4;
      margin: 0;
      transition: color 0.3s ease;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;

      @media (max-width: 768px) {
        font-size: 16px;
      }
    }

    .blurb {
      color: #ccc;
      font-size: 14px;
      margin: 8px 0 0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
`;

export default CardCarouselNews;
